import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function HarmonyOrthoPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-04.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-01.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-02.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-03.png",
    ],
    productName: "Harmony Ortho",
    productLogo:
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/harmony-ortho-logo.png",
    descriptionTitle: "",
    descriptionText:
      "An impeccable combination of Eclipse memory foam and Eclipse 100% Latex on Doctor approved Orthobond Core, Harmony Ortho is the perfect companion for old-age people who require high back support and top-notch comfort. With both-side use mattress quality, it is the harmonical mattress you were looking for.",
    category: { title: "Harmony Collection", link: "/harmony-collection/" },
    points: [
      "Combines Eclipse Memory Foam, Eclipse 100% Latex & medically approved Orthobond Core",
      "High back support & top-notch comfort for age-related issues",
      "Both side mattress use for optimal comfort",
    ],

    featuresText: [
      "Eclipse Memory Foam",
      "Eclipse Orthobond Foam",
      "Eclipse Natural Latex Foam",
    ],

    featuresImage:
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-07.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-08.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-09.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-10.png",
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-11.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/harmony-ortho/HARMONY-ORTHO-n-05.png",
    price: "₹29,799 - ₹1,02,999",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    relatedProducts: [
      {
        title: "Harmony Edge",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmony-edge.jpg",
        link: "/harmony-collection/harmony-edge/",
      },
      {
        title: "Ortho Visco LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-visco-lx.jpg",
        link: "/luxury-collection/ortho-visco-lx/",
      },
      {
        title: "Ortho Latex LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-latex-lx.jpg",
        link: "/luxury-collection/ortho-latex-lx/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Harmony Ortho Mattress | Eclipse International"
        description="Eclipse Harmony ortho mattress is a dual comfort mattress which is perfect companion for old-age people who require high back support and top-notch comfort"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-harmonyortho.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
